import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {AgentInventoryTransactionModel} from "./angular/models/agent-inventory-transaction.model";
import {BringozArray} from "../persistence-layer/bringoz-array";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.agent-inventory')
  .factory('$agentInventory', AgentInventoryArray);

export type $agentInventoryFactory = () => BringozArray<AgentInventoryTransactionModel>;

/* @ngInject */
function AgentInventoryArray($bringozFactory: $bringozFactory, AgentInventoryAPI: BringozApi, AgentInventoryTransactions_DS: DataStoreConfig) {
  function $agentInventory() {
    return $bringozFactory<AgentInventoryTransactionModel>(null, AgentInventoryAPI, AgentInventoryTransactions_DS, null);
  }

  return $agentInventory;
}

